// extracted by mini-css-extract-plugin
export default {"title":"B7olSsHfjW2_vXiIR0Cr","titleText":"knQJ4U934wHNjZI7tu2V","closeModal":"REZscaNrri4iScJn5tCZ","titleWrapper":"tpoNR41WiEGKNsRXyini"};